import React, { useState } from 'react';
import Container from '../../Container/Container';

const FuneralOrder = ({ orderDetails, onSendEmail }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedNotice, setSelectedNotice] = useState('1st');
    const [emailContent, setEmailContent] = useState('');

    // Email templates with placeholders
    const noticeTemplates = {
        '1st': `Dear ${orderDetails?.customerName},

We hope this message finds you well. We wanted to kindly remind you that your order #${orderDetails?.orderNumber} is currently past due.

The total amount due is $${orderDetails?.amount}. Please arrange for payment at your earliest convenience to avoid any service interruptions.

If you've already made this payment, please disregard this notice. For any questions, please contact our customer service team.

Best regards,
${orderDetails?.companyName}`,

        '2nd': `Dear ${orderDetails?.customerName},

This is our second reminder regarding your delinquent order #${orderDetails?.orderNumber}. The outstanding balance of $${orderDetails?.amount} is now significantly past due.

We kindly request immediate payment to prevent any further action. Please note that continued non-payment may result in service suspension.

If payment has already been processed, please provide us with the payment details so we can update our records.

Sincerely,
${orderDetails?.companyName}`,

        '3rd': `Dear ${orderDetails?.customerName},

This is our final notice regarding your seriously delinquent order #${orderDetails?.orderNumber} with an outstanding balance of $${orderDetails?.amount}.

Despite our previous reminders, we have not received payment or communication regarding this matter. Unless payment is received within 48 hours, we will be forced to take further action which may include:

- Suspension of services
- Transfer to collections
- Legal proceedings

To avoid these consequences, please make payment immediately or contact our office to discuss payment arrangements.

Regards,
${orderDetails?.companyName}`
    };

    const handleNoticeChange = (e) => {
        const noticeType = e.target.value;
        setSelectedNotice(noticeType);
        setEmailContent(noticeTemplates[noticeType]);
    };

    const handleContentChange = (e) => {
        setEmailContent(e.target.value);
    };

    const handleSend = () => {
        alert("Static frontend funcinallity")

    };

    return (
        <div className="email-notice-container">
            <br></br>
            <button
                className="email-button"
                onClick={() => setIsModalOpen(true)}
            >
                Email Customer
            </button>

            {isModalOpen && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h2>Send Delinquent Order Notice</h2>

                        <div className="form-group">
                            <label>Select Notice Type:</label>
                            <select
                                value={selectedNotice}
                                onChange={handleNoticeChange}
                                className="notice-select"
                            >
                                <option value="1st">1st Notice</option>
                                <option value="2nd">2nd Notice</option>
                                <option value="3rd">3rd Notice</option>
                            </select>
                        </div>

                        <div className="form-group">
                            <label>Email Content:</label>
                            <textarea
                                value={emailContent || noticeTemplates[selectedNotice]}
                                onChange={handleContentChange}
                                className="email-textarea"
                                rows={12}
                            />
                        </div>

                        <div className="modal-actions">
                            <button
                                className="cancel-button"
                                onClick={() => setIsModalOpen(false)}
                            >
                                Cancel
                            </button>
                            <button
                                className="send-button"
                                onClick={handleSend}
                            >
                                Send Email
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <style jsx>{`
                    .email-notice-container {
                        position: relative;
                        font-family: Arial, sans-serif;
                    }
                    
                    .email-button {
                        background-color: #1890ff;
                        color: white;
                        border: none;
                        padding: 8px 16px;
                        border-radius: 4px;
                        cursor: pointer;
                        font-size: 14px;
                    }
                    
                    .email-button:hover {
                        background-color: #40a9ff;
                    }
                    
                    .modal-overlay {
                        position: fixed;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        background-color: rgba(0, 0, 0, 0.5);
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        z-index: 1000;
                    }
                    
                    .modal-content {
                        background-color: white;
                        padding: 24px;
                        border-radius: 8px;
                        width: 80%;
                        max-width: 800px;
                        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                    }
                    
                    .form-group {
                        margin-bottom: 16px;
                    }
                    
                    label {
                        display: block;
                        margin-bottom: 8px;
                        font-weight: bold;
                    }
                    
                    .notice-select {
                        padding: 8px;
                        width: 200px;
                        border: 1px solid #d9d9d9;
                        border-radius: 4px;
                    }
                    
                    .email-textarea {
                        width: 100%;
                        padding: 8px;
                        border: 1px solid #d9d9d9;
                        border-radius: 4px;
                        resize: vertical;
                        min-height: 200px;
                        font-family: inherit;
                    }
                    
                    .modal-actions {
                        display: flex;
                        justify-content: flex-end;
                        gap: 8px;
                        margin-top: 16px;
                    }
                    
                    .cancel-button {
                        background-color: #f5f5f5;
                        border: 1px solid #d9d9d9;
                        padding: 8px 16px;
                        border-radius: 4px;
                        cursor: pointer;
                    }
                    
                    .send-button {
                        background-color: #1890ff;
                        color: white;
                        border: none;
                        padding: 8px 16px;
                        border-radius: 4px;
                        cursor: pointer;
                    }
                    
                    .send-button:hover {
                        background-color: #40a9ff;
                    }
                `}</style>
        </div>
    );
}

export default FuneralOrder;